<div *ngIf="message" class="grid-description-tooltip">
    <span class="tooltip-message">{{message}}</span>
</div>